// lib/scroll.js
import Lenis from 'lenis';

let lenis;
let parallaxElements = [];

export const initLenis = () => {
	if (!lenis) {
		lenis = new Lenis({
			duration: 1.0,
			lerp: 0.08, // Built-in interpolation (0.08 is a good balance)
			smooth: true,
			syncTouch: true, // Better mobile performance
			touchInertiaMultiplier: 35, // Smoother touch scrolling
			prevent: (node) => node.classList.contains('c-search__container') || node.classList.contains('c-menu__inner') || node.classList.contains('c-modal__embed')
		});

		let rafId;
		const raf = (time) => {
			lenis.raf(time);
			updateParallax();
			rafId = requestAnimationFrame(raf);
		};

		rafId = requestAnimationFrame(raf);

		// Cleanup function
		lenis.destroy = () => {
			if (rafId) {
				cancelAnimationFrame(rafId);
			}
		};
	}

	return lenis;
};

export const getLenis = () => lenis;

// Initialize parallax elements
export const initParallax = () => {
	parallaxElements = Array.from(document.querySelectorAll('.c-parallax')).map(el => {
		const speed = parseFloat(el.getAttribute('data-speed')) || 0.5;
		const reverse = el.getAttribute('data-reverse') === 'true';
		
		return {
			element: el,
			speed,
			reverse
		};
	});
};

// Update parallax transforms
const updateParallax = () => {
	const viewportHeight = window.innerHeight;
	const viewportCenter = viewportHeight / 2;
	
	parallaxElements.forEach(({ element, speed, reverse }) => {
		const rect = element.getBoundingClientRect();
		const elementCenter = rect.top + rect.height / 2;
		
		// Distance from viewport center to element center
		// When element center aligns with viewport center, offset = 0
		const offset = viewportCenter - elementCenter;
		
		// Apply speed multiplier and reverse if needed
		const translateY = offset * speed * (reverse ? -1 : 1);
		
		element.style.transform = `translate3d(0, ${translateY}px, 0)`;
	});
};
